import React, { useState, useEffect } from 'react';
import {NotificationsRounded} from "@mui/icons-material";
import axios from "@common/axios";
import TrailNavigation from "./TrailNavigation";
import TestNavigation from "./TestNavigation";
import MessagesNavigation from "./MessagesNavigation";
import CompetitionsNavigation from "./CompetitionsNavigation";
import FollowUpNavigation from "./FollowUpNavigation";
import AnnouncementsNavigation from "./AnnouncementsNavigation";

const Notifications = props => {
    const {setBadgeCount, fromLogin, ariaLabelledby} = props;
    const [notifications, setNotifications] = useState([]);
    const [notificationCount, setNotificationCount] = useState();

    const getNotifications = () => {
        axios.get('/dashboard/updateNotifications.action', {
            display: fromLogin
        })
            .then(response => {
                if(response.data && Array.isArray(response.data)) {
                    setNotifications(response.data);
                } else {
                    setNotifications([]);
                }
            });
    }
    function openNotificationWS (connectionCount) {
        if (connectionCount > 30) {
            return;
        }
        try {
            const webSocketUrl = ((window.location.protocol === 'https:') ? 'wss://' : 'ws://') + window.location.hostname + (window.location.port ? ':' + window.location.port : '') + '/notificationCheck';
            const socket = new WebSocket(webSocketUrl);
            socket.onmessage = function (event) {
                const data = jQuery.parseJSON(event.data);
                if (data !== null) {
                    setNotifications(notifications => {
                        let newNotifications = [];
                        data.map(newNotification => {
                            if (notifications.find(notification => notification.notificationType === newNotification.notificationType) === undefined) {
                                newNotifications.push(newNotification);
                            } else {
                                notifications.map((notification) => {
                                    if (notification.notificationType === newNotification.notificationType) {
                                        newNotifications.push(newNotification);
                                    } else {
                                        newNotifications.push(notification);
                                    }
                                });
                            }
                        });
                        return newNotifications;
                    });
                }
            }
            socket.onclose = function (event) {
                if (event.code != 1001) {
                    return;
                }
                let reconnectDelay = connectionCount * 50 + 1000;
                if (reconnectDelay > 3000) {
                    reconnectDelay = 3000;
                }
                setTimeout(function () {
                    openNotificationWS(connectionCount + 1);
                }, reconnectDelay);
            }
        } catch (e) {
            console.error('Error connecting to websocket notification', e);
        }
    }

    useEffect(() => {
        getNotifications();
        openNotificationWS();
    }, []);

    useEffect(() => {
        let count = 0;
        notifications.map((notification, index) => {
            if(notification.itemCount > 0) {
                count = count + notification.itemCount;
            }
        });
        setNotificationCount(count);
        setBadgeCount(count);
    }, [notifications]);

    return (
            <ul className={'ch-list ch-nav-group'} aria-labelledby={ariaLabelledby}>
                {notifications.length === 0 &&
                    <li className={'ch-notifications-empty'} tabIndex={-1}>
                        <NotificationsRounded fontSize={'small'} aria-hidden={true} />
                        No new notifications
                    </li>
                }
                {notifications.length > 0 &&
                    notifications.map((notification) => {
                        if(notification.notificationType === 'PATHWAYS') return <TrailNavigation key={'trailsNav'} />
                        if(notification.notificationType === 'TESTS') return <TestNavigation key={'testsNav'} />
                        if(notification.notificationType === 'COMPETITION') return <CompetitionsNavigation notificationDescription={notification.notificationDescription} unreadMessagesCount={notification.itemCount} key={'competitionsNav'} />
                        if(notification.notificationType === 'FOLLOW_UP_WORK') return <FollowUpNavigation key={'followUpsNav'} />
                    })
                }
                <AnnouncementsNavigation key={'announcementsNav'} />
            </ul>
    )
}

export default Notifications;